<template>
  <b-container fluid id="home-projects" class="section">
    <div class="title d-flex justify-content-between align-items-center flex-wrap">
      <h2>Projects</h2>
      <router-link class="nav-route" to="/projects">
        <b-button variant="primary">View All</b-button>
      </router-link>
    </div>
    <b-row>
      <b-col v-for="project in this.projects" :key="project.id" lg="3" md="4" sm="6">
        <project :project_data="project"></project>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Project from "@/components/Project.vue";

export default {
  name: "Projects",
  props: ["projects"],
  components: {
    Project
  },
  data() {
    return {
      pages: null
    };
  }
};
</script>

<style lang="scss">
#home-projects {
  background-color: $light-grey;
}
</style>